import { useMemo } from 'react';

/** 🔥 Patlama Adayları — built from the backend's single decision (row.verdict). */
export const STAGES = {
    AC:       { key: 'AC',       order: 0, verb: 'AÇ',       emoji: '🎯', title: 'Resmi sinyal — pozisyon açılabilir' },
    KUCUK_AC: { key: 'KUCUK_AC', order: 1, verb: 'KÜÇÜK AÇ', emoji: '🚀', title: 'Hareket başladı / etiket yüksek — küçük pozisyon' },
    EMIR_KOY: { key: 'EMIR_KOY', order: 2, verb: 'EMİR KOY', emoji: '🔭', title: 'Tetik bekleniyor — bot koşullu emri koyar' },
    ADAY:     { key: 'ADAY',     order: 3, verb: 'BEKLE',    emoji: '👀', title: 'Kanıt eksik — izle' },
};

const stageOf = (v) => {
    if (!v) return null;
    if (v.action === 'AC' || v.action === 'KUCUK_AC' || v.action === 'EMIR_KOY') return v.action;
    if (v.action === 'BEKLE' && (v.source === 'aday' || v.source === 'etiket')) return 'ADAY';
    return null;
};
const POWER_SCORE = { HIGH: 30, MEDIUM: 20, LOW: 10, NONE: 0, DONE: 0 };

/** Candidates (something may happen) vs. the rest (direction lean only / already ran). */
export function useCandidates(rows) {
    return useMemo(() => {
        const list = [];
        const others = [];
        for (const r of rows || []) {
            const v = r.verdict;
            if (!v) continue;
            const stage = stageOf(v);
            if (stage) list.push({ stage, v, row: r, symbol: r.symbol, score: (v.power || 0) * 10 + (v.explosion_pct != null ? v.explosion_pct / 2 : (POWER_SCORE[v.explosion] || 0)) + (v.confidence || 0) / 10 });
            else others.push({ v, row: r, symbol: r.symbol });
        }
        list.sort((a, b) => STAGES[a.stage].order - STAGES[b.stage].order || b.score - a.score);
        others.sort((a, b) => (a.v.action === 'KOVALAMA') - (b.v.action === 'KOVALAMA') || (b.v.confidence || 0) - (a.v.confidence || 0));
        const counts = Object.fromEntries(Object.keys(STAGES).map((k) => [k, list.filter((c) => c.stage === k).length]));
        return { list, others, counts, late: others.filter((o) => o.v.action === 'KOVALAMA').length };
    }, [rows]);
}
